export enum LetterHeadActionTypes {
    API_RESPONSE_SUCCESS = '@@letterHead/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@letterHead/API_RESPONSE_ERROR',

    ADD_LETTER_HEAD = '@@letterHead/ADD_LETTER_HEAD',
    EDIT_LETTER_HEAD = '@@letterHead/EDIT_LETTER_HEAD',
    GET_LETTER_HEAD = '@@letterHead/GET_LETTER_HEAD',
    GET_SELECTED_LETTER_HEAD = '@@letterHead/GET_SELECTED_LETTER_HEAD',
    GET_LETTER_HEADS = '@@letterHead/GET_LETTER_HEADs',
    RESET = '@@letterHead/RESET',
    RESET_SUCCESS = '@@letterHead/RESET_SUCCESS',
    RESET_ERROR = '@@letterHead/RESET_ERROR',
}
